import { CheckCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const GettingStartedCard = () => {
  const { t } = useTranslation()

  const tasks = [
    {
      text: t('board:getting_started.tasks.onboard'),
      highlight: t('board:getting_started.highlights.onboard'),
    },
    {
      text: t('board:getting_started.tasks.create'),
      highlight: t('board:getting_started.highlights.create'),
    },
    {
      text: t('board:getting_started.tasks.chat'),
      highlight: t('board:getting_started.highlights.chat'),
    },
  ]

  const renderHighlightedText = (text: string, highlight: string) => {
    const parts = text.split(highlight)
    return (
      <>
        {parts[0]}
        <span className="text-orange-500 font-semibold">{highlight}</span>
        {parts[1]}
      </>
    )
  }

  return (
    <div className="bg-stone-50 dark:bg-dark-muted rounded-lg shadow-sm border border-stone-300 dark:border-dark-border p-4 max-w-md">
      {/* Title */}
      <h2 className="text-xl font-semibold text-gray-800 dark:text-dark-text mb-6">
        {t('board:getting_started.title')}
      </h2>

      {/* Checklist */}
      <div className="space-y-4 mb-6">
        {tasks.map((task, index) => (
          <div key={index} className="flex items-start gap-3">
            <CheckCircle className="w-5 h-5 text-gray-400 dark:text-gray-500 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
              {renderHighlightedText(task.text, task.highlight)}
            </p>
          </div>
        ))}
      </div>

      {/* TODO (INTUIAI-669): Add video */}
    </div>
  )
}

export default GettingStartedCard
